export const CREATE_CITY_PLAN = 'CREATE_CITY_PLAN'
export const CREATE_CITY_PLAN_SUCCESS = 'CREATE_CITY_PLAN_SUCCESS'

export const EDIT_CITY_PLAN = 'EDIT_CITY_PLAN'
export const EDIT_CITY_PLAN_SUCCESS = 'EDIT_CITY_PLAN_SUCCESS'

export const DELETE_CITY_PLAN_BY_ID = 'DELETE_CITY_PLAN_BY_ID'
export const DELETE_CITY_PLAN_BY_ID_SUCCESS = 'DELETE_CITY_PLAN_BY_ID_SUCCESS'

export const CREATE_CAMPAIGN = 'CREATE_CAMPAIGN'
export const CREATE_CAMPAIGN_SUCCESS = 'CREATE_CAMPAIGN_SUCCESS'

export const UPDATE_CAMPAIGN = 'UPDATE_CAMPAIGN'
export const UPDATE_CAMPAIGN_SUCCESS = 'UPDATE_CAMPAIGN_SUCCESS'

export const GET_CAMPAIGN_BY_ID = 'GET_CAMPAIGN_BY_ID'
export const GET_CAMPAIGN_BY_ID_SUCCESS = 'GET_CAMPAIGN_BY_ID_SUCCESS'
export const GET_CAMPAIGN_BY_ID_ERROR = 'GET_CAMPAIGN_BY_ID_ERROR'
export const CLEAR_CAMPAIGN_BY_ID = 'CLEAR_CAMPAIGN_BY_ID'

export const GET_CAMPAIGNS = 'GET_CAMPAIGNS'
export const GET_ACTIVE_CAMPAIGNS = 'GET_ACTIVE_CAMPAIGNS'

export const GET_CAMPAIGNS_SUCCESS = 'GET_CAMPAIGNS_SUCCESS'
export const GET_ACTIVE_CAMPAIGNS_SUCCESS = 'GET_ACTIVE_CAMPAIGNS_SUCCESS'

export const GET_CAMPAIGNS_ERROR = 'GET_CAMPAIGNS_FAIL'

export const GET_CAMPAIGNS_BY_CLIENT_ID = 'GET_CAMPAIGNS_BY_CLIENT_ID'
export const GET_CAMPAIGNS_BY_CLIENT_ID_SUCCESS =
  'GET_CAMPAIGNS_BY_CLIENT_ID_SUCCESS'
export const GET_CAMPAIGNS_BY_CLIENT_ID_ERROR =
  'GET_CAMPAIGNS_BY_CLIENT_ID_ERROR'
export const RESET_CAMPAIGNS_BY_CLIENT_ID = 'RESET_CAMPAIGNS_BY_CLIENT_ID'

export const SET_CAMPAIGNS_STATUS_FILTER = 'SET_CAMPAIGNS_STATUS_FILTER'

export const GET_CITY_PLAN_BY_ID = 'GET_CITY_PLAN_BY_ID'
export const GET_CITY_PLAN_BY_ID_SUCCESS = 'GET_CITY_PLAN_BY_ID_SUCCESS'
export const GET_CITY_PLAN_BY_ID_ERROR = 'GET_CITY_PLAN_BY_ID_ERROR'
export const CLEAR_CITY_PLAN_BY_ID = 'CLEAR_CITY_PLAN_BY_ID'

export const GET_CITY_PLANS_BY_CAMPAIGN_ID_FOR_FLYER_CODES_FORM =
  'GET_CITY_PLANS_BY_CAMPAIGN_ID_FOR_FLYER_CODES_FORM'
export const GET_CITY_PLANS_BY_CAMPAIGN_ID_FOR_FLYER_CODES_FORM_SUCCESS =
  'GET_CITY_PLANS_BY_CAMPAIGN_ID_FOR_FLYER_CODES_FORM_SUCCESS'
export const SET_CITY_PLANS_BY_CAMPAIGN_ID_SORT_BY =
  'SET_CITY_PLANS_BY_CAMPAIGN_ID_SORT_BY'
export const SET_CITY_PLANS_BY_CAMPAIGN_ID_CITY_FILTER =
  'SET_CITY_PLANS_BY_CAMPAIGN_ID_CITY_FILTER'
export const CLEAR_CITY_PLANS_BY_CAMPAIGN_ID_CITY_FILTER =
  'CLEAR_CITY_PLANS_BY_CAMPAIGN_ID_CITY_FILTER'

export const SET_CAMPAIGNS_CLIENT_FILTER = 'SET_CAMPAIGNS_CLIENT_FILTER'
export const SET_CAMPAIGNS_COUNTRY_FILTER = 'SET_CAMPAIGNS_COUNTRY_FILTER'
export const SET_CLIENT_VIEW_CAMPAIGNS_STATUS_FILTER =
  'SET_CLIENT_VIEW_CAMPAIGNS_STATUS_FILTER'
export const RESET_CLIENT_VIEW_CAMPAIGNS_STATUS_FILTER =
  'RESET_CLIENT_VIEW_CAMPAIGNS_STATUS_FILTER'

export const ADD_FLYER_CODES_BY_CITY_PLAN_ID = 'ADD_FLYER_CODES_BY_CITY_PLAN_ID'
export const ADD_FLYER_CODES_BY_CITY_PLAN_ID_SUCCESS =
  'ADD_FLYER_CODES_BY_CITY_PLAN_ID_SUCCESS'

export const UPLOAD_CONVERSION_REPORT = 'UPLOAD_CONVERSION_REPORT'
export const UPLOAD_CONVERSION_REPORT_SUCCESS =
  'UPLOAD_CONVERSION_REPORT_SUCCESS'

export const ADD_CONVERSION_REPORT = 'ADD_CONVERSION_REPORT'
export const ADD_CONVERSION_REPORT_SUCCESS = 'ADD_CONVERSION_REPORT_SUCCESS'

export const CITY_PLANS_BY_CAMPAIGN_ID_CITY_FILTER_OPTIONS = [
  { label: 'All', value: null },
]
export const GET_CAMPAIGN_RESULTS = 'GET_CAMPAIGN_RESULTS'
export const GET_CAMPAIGN_RESULTS_SUCCESS = 'GET_CAMPAIGN_RESULTS_SUCCESS'
